import FormBase from "../FormBase";
import FormFieldBase from "../FormFieldBase";
import Professional from '../../models/Professional'
import ValidationBase, { ValidationType } from "../ValidationBase";
import AddressService from "../../services/AddressService";
import Address from "../../models/Address";
import OptionItem from "../../models/OptionItem";
import { cepMaskValue } from "../../helpers/Masks/CEPMask";

export enum AddressType {
    PERSONAL = 1,
    BUSINESS = 2
}

export default class AddressDataForm implements FormBase {

    Address: FormFieldBase;
    Number: FormFieldBase;
    Complement: FormFieldBase;
    City: FormFieldBase;
    State: FormFieldBase;
    Neighborhood: FormFieldBase;
    CEP: FormFieldBase;
    AddressType: AddressType;


    constructor(Address: string, Number: string, Complement: string, City: string, State: string, Neighborhood: string, CEP: string, PhoneNumber: string, addressType: AddressType) {

        this.AddressType = addressType;
        this.Complement = new FormFieldBase(Complement, []);;

        if (this.AddressType === AddressType.BUSINESS) {

            this.Address = new FormFieldBase(Address, [], () => "", (value: any) => { this.InputChangeCustom(value) });
            this.Number = new FormFieldBase(Number, [], () => "", (value: any) => { this.InputChangeCustom(value) });
            this.City = new FormFieldBase(City, [], () => "", (value: any) => { this.InputChangeCustom(value) });
            this.State = new FormFieldBase(State, [], () => "", (value: any) => { this.InputChangeCustom(value) });
            this.Neighborhood = new FormFieldBase(Neighborhood, [], () => "", (value: any) => { this.InputChangeCustom(value) });
            this.CEP = new FormFieldBase(CEP, [], () => "", (value: any) => { this.InputChangeCustom(value) });

            this.Address.Mandatory = false;
            this.Number.Mandatory = false;
            this.City.Mandatory = false;
            this.State.Mandatory = false;
            this.Neighborhood.Mandatory = false;
            this.CEP.Mandatory = false;


        } else {

            this.Address = new FormFieldBase(Address, [new ValidationBase("", ValidationType.OBRIGATORIO)]);;
            this.Number = new FormFieldBase(Number, [new ValidationBase("", ValidationType.OBRIGATORIO)]);;
            this.City = new FormFieldBase(City, [new ValidationBase("", ValidationType.OBRIGATORIO)]);;
            this.State = new FormFieldBase(State, [new ValidationBase("", ValidationType.OBRIGATORIO)]);;
            this.Neighborhood = new FormFieldBase(Neighborhood, [new ValidationBase("", ValidationType.OBRIGATORIO)]);;
            this.CEP = new FormFieldBase(CEP, [new ValidationBase("", ValidationType.OBRIGATORIO), new ValidationBase("", ValidationType.CEP)]);;
        }
    }

    static NewInstance(AddressType: AddressType): AddressDataForm {
        return new AddressDataForm("", "", "", "", "", "", "", "", AddressType);
    }

    async CallInsertOrUpdateApi(Professional: Professional): Promise<any> {

        let propNames = Object.getOwnPropertyNames(this);

        let existFieldImputed = false;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];

            if (element !== "Complement" && element !== "AddressType") {

                const value = this.GetFieldByName(element).Value;

                if (value != null && value !== "" && value.toString().trim() !== "") {
                    existFieldImputed = true;
                }
            }
        }

        if (existFieldImputed) {
            const dataJson = this.getJsonObjet();
            return AddressService.postInsertOrUpdateAddress(dataJson, Professional.Id);
        } else {
            return Promise.resolve(true);
        }

    }

    async PreloadFormFromApi(requestId: string): Promise<any> {

        return await AddressService.CreateAndGetAddressFromTasy(requestId, this.AddressType).then((data: Address) => {

            if (data !== undefined && data.CEP !== "" && data.CEP !== null && data.CEP !== undefined) {
                this.CEP.Value = cepMaskValue(data.CEP);
                this.Address.Value = data.AddressName;
                this.Number.Value = data.NumberAddress;
                this.Complement.Value = data.Complement;
                this.City.Value = data.City;
                this.Neighborhood.Value = data.Neighborhood;

                if (data.StateAddress !== undefined) {
                    this.State.Value = new OptionItem(data.StateAddress.Id, data.StateAddress.Description, data.StateAddress.Id)
                }
            }

        });
    }

    InputChangeCustom(Value: any): void {

        if (Value != null && Value !== "") {

            this.Address.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
            this.Number.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
            this.City.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
            this.State.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
            this.Neighborhood.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
            this.CEP.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO), new ValidationBase("", ValidationType.CEP)];

            this.Address.Mandatory = true;
            this.Number.Mandatory = true;
            this.City.Mandatory = true;
            this.State.Mandatory = true;
            this.Neighborhood.Mandatory = true;
            this.CEP.Mandatory = true;

        } else {

            let propNames = Object.getOwnPropertyNames(this);

            let existFieldImputed = false;

            for (let index = 0; index < propNames.length; index++) {
                const element = propNames[index];

                if (element !== "Complement" && element !== "AddressType") {

                    const value = this.GetFieldByName(element).Value;

                    if (value != null && value !== "" && value.toString().trim() !== "") {
                        existFieldImputed = true;
                    }
                }
            }

            if (existFieldImputed) {
                this.Address.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
                this.Number.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
                this.City.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
                this.State.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
                this.Neighborhood.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
                this.CEP.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO), new ValidationBase("", ValidationType.CEP)];

                this.Address.Mandatory = true;
                this.Number.Mandatory = true;
                this.City.Mandatory = true;
                this.State.Mandatory = true;
                this.Neighborhood.Mandatory = true;
                this.CEP.Mandatory = true;
            } else {
                this.Address.Validations = [];
                this.Number.Validations = [];
                this.City.Validations = [];
                this.State.Validations = [];
                this.Neighborhood.Validations = [];
                this.CEP.Validations = [];

                this.Address.Mandatory = false;
                this.Number.Mandatory = false;
                this.City.Mandatory = false;
                this.State.Mandatory = false;
                this.Neighborhood.Mandatory = false;
                this.CEP.Mandatory = false;

                this.Address.Error = "";
                this.Number.Error = "";
                this.City.Error = "";
                this.State.Error = "";
                this.Neighborhood.Error = "";
                this.CEP.Error = "";
            }
        }
    }


    ValidateToGoNextStep(): string {

        let propNames = Object.getOwnPropertyNames(this);

        let formIsValid = true;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            const error = this.GetFieldByName(element).ValidateField();

            if (error !== null && error !== "") {
                formIsValid = false;
            }
        }

        if (!formIsValid) {
            return "Por favor, preencha os dados obrigatórios."
        } else {
            return "";
        }
    }

    GetFieldByName(name: string): FormFieldBase {
        switch (name) {
            case "CEP":
                return this.CEP

            case "Address":
                return this.Address

            case "Neighborhood":
                return this.Neighborhood

            case "Number":
                return this.Number

            case "Complement":
                return this.Complement

            case "City":
                return this.City

            case "State":
                return this.State

            default:
                return new FormFieldBase("", []);
        }
    }

    getJsonObjet() {

        return {
            "ProfessionalId": 0,
            "AddressName": this.Address.Value,
            "NumberAddress": this.Number.Value,
            "Complement": this.Complement.Value,
            "City": this.City.Value,
            "State": this.State.Value.Value,
            "Neighborhood": this.Neighborhood.Value,
            "CEP": this.CEP.Value,
            "AddressType": this.AddressType
        }
    }
}


